import { HTMLProps } from 'react'
import clsx from 'classnames'
import { ArrowXAxisIcon } from '@/shared/icons/arrow-x-axis-icon'
import style from './slider-navigation.module.scss'

interface AnalyticsSliderNavigationProps extends HTMLProps<HTMLDivElement> {
  onPrevButtonClick: () => void
  onNextButtonClick: () => void
}

export const SliderNavigation = (props: AnalyticsSliderNavigationProps) => {
  const { onPrevButtonClick, onNextButtonClick } = props

  return (
    <nav className={style.nav}>
      <button
        className={style.navButton}
        onClick={e => {
          e.stopPropagation()
          onPrevButtonClick()
        }}
      >
        <ArrowXAxisIcon className={clsx(style.arrow, 'arrow-icon')} direction="prev" />
      </button>
      <button
        className={style.navButton}
        onClick={e => {
          e.stopPropagation()
          onNextButtonClick()
        }}
      >
        <ArrowXAxisIcon className={clsx(style.arrow, 'arrow-icon')} direction="next" />
      </button>
    </nav>
  )
}
